import { render, staticRenderFns } from "./AssessmentsMobile.vue?vue&type=template&id=1d06ff0a&scoped=true"
import script from "./AssessmentsMobile.vue?vue&type=script&lang=js"
export * from "./AssessmentsMobile.vue?vue&type=script&lang=js"
import style0 from "./AssessmentsMobile.vue?vue&type=style&index=0&id=1d06ff0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d06ff0a",
  null
  
)

export default component.exports